import { useState } from "react"
import { FiX } from "react-icons/fi"
import { useModal } from "../../stores/useModal"

export const Preview = ({values:{path}}) => {
    const [photo, setPhoto] = useState(path.path||`/images/shared/car.jpg`)
    const {toggle} = useModal(state=>state)
    return (
        <div class=" h-full w-full p-5 flex items-center justify-center">
            <div class="relative flex items-center justify-center z-[200]">
            <img
                src={photo}
                class="w-screen sm:max-w-[1024px] max-h-[550px] mb-20 rounded-md object-contain h-full"
            />
            </div>
            <div
                class="z-[200] absolute left-0 right-0 bottom-5 w-full flex items-center justify-center gap-2"
            >
            {[
            {path:"car.jpg"},
            {path:"camera.jpg"},
            {path:"Rectangle 3.png"},
            {path:"Rectangle 4.png"},
            {path:"Rectangle 5.png"},
            {path:"Rectangle 6.png"},
            {path:"Rectangle 7.png"},
            {path:"Rectangle 8.png"},
            ].map(image=>(
                <img
                    onClick={()=>setPhoto(`/images/shared/${image.path}`)}
                    src={`/images/shared/${image.path}`}
                    class="w-16 h-16 object-cover cursor-pointer rounded-md border-2 border-gray-100 dark:border-black/20"
                />
            ))}
           
            </div>

            <div
                    onClick={()=>toggle()}
                    class="absolute right-4 top-4 cursor-pointer z-[205] flex 
                    bg-gray-500 hover:bg-gray-600 p-2 rounded-full text-white 
                    cursor-pointer items-center justify-center"
                >
                    <FiX size={23} />
                </div>


        </div>
    )
}